// extracted by mini-css-extract-plugin
module.exports = {"mainViewCatch":"MainViewCatch_mainViewCatch__OVVan"};